import {
  ERROR_CSV,
  FETCHING_CSV,
  RECEIVE_CSV,
  CLEAR_ERROR_OR_DATA,
  PUBLISH_PERMISSION_MATRIX
} from '../actions/actionTypes';

const menuInit = {
  isFetching: false,
  objectBlob: null,
  error: null,
  topic: null
};

const reportsReducer = (state = menuInit, action) => {
  switch (action.type) {
    case FETCHING_CSV:
      return Object.assign({}, state, { isFetching: true, objectBlob: null, error: null, topic: null });
    case RECEIVE_CSV:
      return Object.assign(
        {},
        state,
        { isFetching: false, objectBlob: null, error: null, topic: null },
        action.payload
      );
    case ERROR_CSV:
      return Object.assign(
        {},
        state,
        { isFetching: false, objectBlob: null, error: null, topic: null },
        action.payload
      );
    case CLEAR_ERROR_OR_DATA:
      return Object.assign({}, state, { isFetching: false, objectBlob: null, error: null, topic: null });
    case PUBLISH_PERMISSION_MATRIX:
      return Object.assign({}, state, { matrix: action.payload });
    default:
      return state;
  }
};

export default reportsReducer;
